import type { FC } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HTMLCommentProps {
  text: string;
}

/**
 * A React component that renders an HTML comment.
 * Comments are rendered as <meta> to prevent Next.JS from removing them
 * @param {Object} props - The props object for the component.
 * @param {string} props.text - The text content of the HTML comment.
 * @returns {JSX.Element} A JSX element that represents the HTML comment.
 */
export const HTMLComment: FC<HTMLCommentProps> = (props: HTMLCommentProps) => {
  return <div data-name="dp-comment" content={props.text} />;
};
